import * as React from 'react';
import { DrawerLayout } from '@brightlayer-ui/react-components';
import { SideNav } from '../SideNav/SideNav';
import useStateWhileMounted from '../../hooks/use-state-while-mounted';
import { useDispatch, useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { Actions } from '../../actions';
// import { Box } from '@mui/material';

type ConfigurePageContainerContext = {
    displaySideNav: boolean;
    setDisplaySideNav: Function; // TODO: type this
};

const ConfigurePageContainerContext = React.createContext<ConfigurePageContainerContext | null>(null);

export const useConfigurePageContainer = (args: { displaySideNav: boolean; appBar?: React.ReactElement }): void => {
    const context = React.useContext(ConfigurePageContainerContext);
    if (!context) {
        throw new Error('useConfigurePageContainer must be a child of a PageContainer');
    }

    React.useLayoutEffect(() => {
        if (context.displaySideNav !== args.displaySideNav) {
            context.setDisplaySideNav(args.displaySideNav);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export const PageContainer: React.FC = (props) => {
    const Dispatch = useDispatch();
    const timelineCsvUrl = useSelector(Selectors.TimelineExport.timelineExportUrl);
    React.useEffect(() => {
        if (timelineCsvUrl !== '') window.open(timelineCsvUrl, '_self');
        return (): void => {
            Dispatch(Actions.TimelineExport.timelineExportUnmounted());
        };
    }, [timelineCsvUrl]); // eslint-disable-line react-hooks/exhaustive-deps
    const [displaySideNav, setDisplaySideNav] = useStateWhileMounted(false);

    return (
        <ConfigurePageContainerContext.Provider value={{ displaySideNav, setDisplaySideNav }}>
       
            <DrawerLayout drawer={<SideNav />} >{props.children}</DrawerLayout>
          
        </ConfigurePageContainerContext.Provider>
    );
};
